import { Component, OnInit, Injector, ChangeDetectorRef } from "@angular/core"
import { BaseRegisterCompletarSocialComponent } from "../base_register_completar_social.component"
import {
    Usuarios,
    GrupoUsuarios,
    Establecimientos,
    Lugar,
    Lugares,
    UsuarioRegistroCB,
    UsuarioRegistroCBForm,
    UsuariosCompletarRegistroSocialCbForm
} from "@puntaje/puntaje/api-services"
import { AuthService, SessionService, BaseForm } from "@puntaje/shared/core"
import { Router } from "@angular/router"
import { Clasificaciones } from "@puntaje/nebulosa/api-services"

@Component({
    selector: "usuario-completar-registro-social-cb",
    templateUrl: "./usuario-completar-registro-social-cb.component.html",
    styleUrls: ["./usuario-completar-registro-social-cb.component.scss"]
})
export class UsuarioCompletarRegistroSocialCbComponent extends BaseRegisterCompletarSocialComponent {
    formType: typeof BaseForm = UsuariosCompletarRegistroSocialCbForm
    params: any = this.formType.formParams

    constructor(
        usuariosService: Usuarios,
        authService: AuthService,
        sessionService: SessionService,
        router: Router,
        injector: Injector,
        grupoUsuariosService: GrupoUsuarios,
        cdr: ChangeDetectorRef,
        establecimientosService: Establecimientos,
        lugaresService: Lugares,
        clasificacionesService: Clasificaciones
    ) {
        super(
            usuariosService,
            authService,
            sessionService,
            router,
            injector,
            grupoUsuariosService,
            cdr,
            establecimientosService,
            lugaresService,
            clasificacionesService
        )
    }

    save() {
        delete this.usuario["usuario_" + this.pais]

        if (JSON.parse(localStorage.getItem("fechaNacimiento"))) {
            this.usuario.fecha_nacimiento = JSON.parse(localStorage.getItem("fechaNacimiento"))
        }

        super.save()
    }
}
